import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible/flexible'
import router from './router'
import { Toast } from 'vant';
import { Lazyload } from 'vant';
Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Toast);
Vue.use(Lazyload);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
